import React, { createContext, useState, useEffect } from 'react';

// 检测系统主题偏好
const getSystemTheme = () => {
  if (typeof window !== 'undefined' && window.matchMedia) {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }
  return 'light';
};

// 获取实际应用的主题（如果theme是'auto'，则返回系统主题）
const getActualTheme = (theme) => {
  return theme === 'auto' ? getSystemTheme() : theme;
};

export const ThemeContext = createContext({
  theme: 'auto',
  actualTheme: 'light',
  toggleTheme: () => {},
});

export const ThemeProvider = ({ children }) => {
  // 从localStorage读取保存的主题，默认为auto（跟随系统）
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme || 'auto';
  });

  // 计算实际应用的主题
  const actualTheme = getActualTheme(theme);

  // 初始化时应用主题
  useEffect(() => {
    const currentTheme = getActualTheme(theme);
    document.body.className = currentTheme === 'dark' ? 'dark-mode' : '';
  }, []); // 仅在组件挂载时执行

  useEffect(() => {
    // 应用主题到body元素
    const currentTheme = getActualTheme(theme);
    document.body.className = currentTheme === 'dark' ? 'dark-mode' : '';
    // 保存主题到localStorage
    localStorage.setItem('theme', theme);
  }, [theme]);

  // 监听系统主题变化（仅在auto模式下）
  useEffect(() => {
    if (theme !== 'auto') return;

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    
    const handleChange = (e) => {
      const systemTheme = e.matches ? 'dark' : 'light';
      document.body.className = systemTheme === 'dark' ? 'dark-mode' : '';
    };

    // 监听变化
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleChange);
    } else {
      // 兼容旧版浏览器
      mediaQuery.addListener(handleChange);
    }

    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener('change', handleChange);
      } else {
        mediaQuery.removeListener(handleChange);
      }
    };
  }, [theme]);

  const toggleTheme = () => {
    // 循环切换：auto -> light -> dark -> auto
    setTheme(prevTheme => {
      if (prevTheme === 'auto') return 'light';
      if (prevTheme === 'light') return 'dark';
      return 'auto';
    });
  };

  return (
    <ThemeContext.Provider value={{ theme, actualTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

